import { render, staticRenderFns } from "./cicadama.vue?vue&type=template&id=9f53fbe2&scoped=true&"
import script from "./cicadama.vue?vue&type=script&lang=js&"
export * from "./cicadama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f53fbe2",
  null
  
)

export default component.exports